import SendMailIcon from "@assets/images/send-mail.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

export interface BottomBarSendMailProps {
  selectedLine: number;
  disabled?: boolean;
  onSendMail: () => void;
}

interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsStyleType>(
  () => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 20,
      height: 90,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 9,
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)"
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center"
    },
    ml_20: {
      marginLeft: "2rem"
    },
    icon: {
      marginRight: "1.1rem"
    },
    textButton: {
      fontSize: "1.8rem",
      lineHeight: "24px",
      fontWeight: 400,
      marginLeft: "0.8rem"
    },
    btnCustom: {
      minWidth: "20rem"
    }
  }),
  { name: "BottomBarSendMail" }
);

const BottomBarSendMail: React.FC<BottomBarSendMailProps> = props => {
  const { selectedLine, onSendMail, disabled } = props;
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });

  return (
    <div data-testid="bottom-bar" className={classes.bottomBar}>
      <div className={classes.barRight}>
        <MyTypography variant="body2">
          เลือก <b>{selectedLine}</b> รายการ
        </MyTypography>
        <div className={classes.ml_20}>
          <Button
            className={classes.btnCustom}
            variant={"contained"}
            color={"secondary"}
            disabled={disabled}
            onClick={onSendMail}
          >
            <SVG src={SendMailIcon} width={20} />
            <span className={classes.textButton}>
              <FormattedMessage defaultMessage={"Send Mail"} />
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBarSendMail;
